import {
  COMPONENT_PUBLISH_REQUESTED,
  COMPONENT_PUBLISH_SUCCESS,
  COMPONENT_PUBLISH_REJECTED
} from './const';

/**
 * Returns action for component publish now
 * @param {object} component - the component to publish.
 * @param {boolean} publishNow - flag for publsh now
 * @param {string} dateTime - datetime of the schedule to publish the component.
 * @returns {object} Action Object
 */
export const componentPublish = (component, publishNow, dateTime) => ({
  type: COMPONENT_PUBLISH_REQUESTED,
  component,
  publishNow,
  dateTime
});

/**
 * Returns action for component schedule publish success
 * @param {object} response - success response from schedule to publish the component.
 * @returns {object} Action Object
 */
export const componentPublishSuccess = response => ({
  type: COMPONENT_PUBLISH_SUCCESS,
  response
});

/**
 * Returns action for component schedule publish
 * @param {object} component - component object for which publish component was invoked.
 * @param {object} response - failure response from schedule to publish the component.
 * @returns {object} Action Object
 */
export const componentPublishFailure = (component, response) => ({
  type: COMPONENT_PUBLISH_REJECTED,
  component,
  response
});
